/**
 * Dynamische SEO Meta-Tags setzen
 */
export function setMetaTags({ title, description, image, url, type = 'website', keywords, robots = 'index, follow' }) {
  // Title setzen
  if (title) {
    document.title = title;
  }

  // Helper-Funktion zum Setzen von Meta-Tags
  const setMeta = (selector, content) => {
    if (!content) return;

    let element = document.querySelector(selector);
    if (!element) {
      // Wenn das Element nicht existiert, erstelle es
      const [attr, value] = selector.match(/\[(.+)="(.+)"\]/).slice(1);
      element = document.createElement('meta');
      element.setAttribute(attr, value);
      document.head.appendChild(element);
    }
    element.setAttribute('content', content);
  };

  // Standard Meta-Tags
  if (description) {
    setMeta('meta[name="description"]', description);
  }

  if (keywords) {
    setMeta('meta[name="keywords"]', keywords);
  }

  // Robots Meta-Tag
  setMeta('meta[name="robots"]', robots);

  // Open Graph Tags
  if (title) {
    setMeta('meta[property="og:title"]', title);
  }

  if (description) {
    setMeta('meta[property="og:description"]', description);
  }

  if (image) {
    setMeta('meta[property="og:image"]', image);
  }

  if (url) {
    setMeta('meta[property="og:url"]', url);
  }

  if (type) {
    setMeta('meta[property="og:type"]', type);
  }

  // Twitter Card Tags
  if (title) {
    setMeta('meta[name="twitter:title"]', title);
  }

  if (description) {
    setMeta('meta[name="twitter:description"]', description);
  }

  if (image) {
    setMeta('meta[name="twitter:image"]', image);
  }

  // Canonical URL
  let canonical = document.querySelector('link[rel="canonical"]');
  if (url) {
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', url);
  }
}

/**
 * Strukturierte Daten (JSON-LD) für Blog-Artikel hinzufügen
 */
export function setStructuredData(data) {
  // Entferne vorherige strukturierte Daten
  const existingScript = document.querySelector('script[type="application/ld+json"]');
  if (existingScript) {
    existingScript.remove();
  }

  // Füge neue strukturierte Daten hinzu
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.text = JSON.stringify(data);
  document.head.appendChild(script);
}
